import { Entry } from '../Entry'

export function Entry20210930() {
  return (
    <Entry title="09/30/2021 - v3.0.0-beta-9">
      All the included are listed in the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12296/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
